import {
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
  
import { CommonModule, formatDate } from '@angular/common';
import { PaisService } from 'src/app/core/services/pais.service';
import { EspecialistaAgendaService } from 'src/app/core/services/especialista-agenda.service';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

import { FlatpickrModule } from 'angularx-flatpickr';

import { ServiciosService } from 'src/app/core/services/servicios.service';
import { EspecialistaService } from 'src/app/core/services/especialista.service';
import { Especialista } from 'src/app/core/models/especialista.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PaquetesAdquiridosService } from 'src/app/core/services/paquetes-adquiridos.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfigService } from 'src/app/core/services/config.service';
import Swal from 'sweetalert2';
import { CitaService } from 'src/app/core/services/cita.service';
import { Router } from '@angular/router';
import { CitasPagosService } from 'src/app/core/services/citas-pagos.service';
import { TiposDocumentoService } from 'src/app/core/services/tipos-documento.service';
import { ParentescoService } from 'src/app/core/services/parentesco.service';
import { firstValueFrom } from 'rxjs';
import { PacientesService } from 'src/app/core/services/paciente.service';
import { UserService } from 'src/app/core/services/user.service';
import { UsuariosRelaciones } from 'src/app/core/models/usuarios-relaciones.model';

// Traemos el html y scss y creamos el selector para usar el componente en citas-list-new
@Component({
  standalone: true,
  selector: 'app-agenda-especialista',
  templateUrl: './agenda-especialista.component.html',
  styleUrls: ['./agenda-especialista.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule, FlatpickrModule],
})
export class AgendaEspecialistaComponent {
  @Input() idEspecialista!: string;
  @Input() datosPaciente!: any;
  @ViewChild('confirmModal') confirmModal!: TemplateRef<any>;
  @ViewChild('createPaciente') createPaciente!: TemplateRef<any>;

  @ViewChild('estadoSelect') estadoSelect: any;
  @ViewChild('ciudadSelect') ciudadSelect: any;

  

  private modalReferences: { [key: string]: NgbModalRef } = {};

  // Variable usada para validar si los datos de paises, t documentos y ciudades y estados ya se cargaron antes
  private datosBasicosCargados = false;
  // Esta variable es usada cuando cambia el día seleccionado se guarde. Pero si se selecciona la hora no es necesario volver a cargar el id del horario
  horarioIdCargado = '';

  horarios: any[] = [];
  cargando = false;
  horariosVisible = false;
  fechaActual = new Date();
  diasMostrados: Date[] = [];
  diaSeleccionado: Date | null = null;

  // Formulario para agendar cita
  formData: FormGroup;

  // Datos del especialista
  datosEspecialista: any = [];
  serviciosEspecialista = [];
  servicios = [];

  // DATOS DEL PACIENTE
  paquetesPaciente = [];
  formDataPaciente: FormGroup;
  // datos del paciente a mostrar para que confirme que es el paciente correcto
  datosConfirmar = {
    nombresede: '',
    idSede: '',
    direccionSede: '',
    consultorio: '',
    fechaCita: '',
    startEvent: null,
    horaCita: '',
    paciente: '',
  };
  requiredContact: boolean = false;
  submittedPaciente: boolean = false;
  parentescos: any = [];
  tiposDocumento: any = [];
  paises: any = [];
  departamentos: any = [];
  ciudades: any = [];

  idUsuarioAsigna: string;
  tUsuarioAsigna: string;
  nombreUsuarioAsigna: string;
  servicioSeleccionado = null;
  nombresede: string = '';
  direccionSede: string = '';
  consultorio: string = '';
  fechaCita: string = '';
  valorTotal: number = 0;
  valorServicio: number = 0;
  descuento: number = 0;
  idServiciosEspecialista = [];
  submitted: boolean;
  duracion: number = 0;
  telefono_soporte: string;

  //Datos para la agenda
  @Input() convenios: any[] = [];

  constructor(
    private fb: FormBuilder,
    private __paisService: PaisService,
    private __especialistaAgendaService: EspecialistaAgendaService,
    private __especialistasService: EspecialistaService,
    private __serviciosService: ServiciosService,
    private modalService: NgbModal,
    private __paquetesAdquiridosService: PaquetesAdquiridosService,
    private configService: ConfigService,
    private __citasservice: CitaService,
    private router: Router,
    private __citasPagosService: CitasPagosService,

    private __tiposDocumentoService: TiposDocumentoService,
    private __parentescoService: ParentescoService,
    private __pacientesService: PacientesService,
    private __userService: UserService,
    private cdr: ChangeDetectorRef
  ) {
    this.formData = this.fb.group({
      modalidad: ['Presencial', Validators.required],
      servicio: ['', Validators.required],
      duracion: ['', Validators.required],
      convenio: ['NO'],
      detalle: [''],
    });
    // FORMULARIO DEL PACIENTE
    this.formDataPaciente = this.fb.group({
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      tDocumento: [null, Validators.required],
      identificacion: ['', Validators.required],
      celular: [, Validators.required],
      email: ['', [Validators.required, Validators.email]],
      fnacimiento: ['', Validators.required],

      contactoNombre: [''],
      contactoParentesco: [''],
      contactoTelefono: [''],

      idPaisResidencia: ['CO', Validators.required],
      idEstadoResidencia: [null, Validators.required], //DEPARTAMENTO
      idCiudadResidencia: [null, Validators.required],
    });
  }

  ngOnInit() {
    // YA NO necesitamos obtener datos de sesión aquí porque vienen como @Input()
    // Los datosPaciente se reciben desde CitasListNewComponent
    
    //console.log('Datos del paciente recibidos como Input:', this.datosPaciente);
    
    /* Si necesitas hacer algo específico cuando recibes datos del paciente
    if (this.datosPaciente) {
      console.log('Paciente disponible en agenda:', this.datosPaciente);
    }*/
  
    // Función para listar todos los días de la semana
    this.generarDiasMostrados();
    this.diaSeleccionado = this.diasMostrados[0];
  }


  async agendarCita(horario: any) {
    // // Resetear valores
    this.selectNoConvenio(); // Cambia a 'NO'
    this.descuento = 0;

    // Horarios
    // console.log('horarios', this.horarios);

    // console.log('Horario seleccionado:', horario);
    // console.log('this.idEspecialista:', this.idEspecialista);
    // Trae agenda del especialista
    //console.log('horario.id', horario.id);
    //console.log('horarioIdCargado', this.horarioIdCargado);

    // Esta validación evita que se vuelva a cargar todo de nuevo solo hasta que se cambie el día.
    if (horario.id != this.horarioIdCargado) {
      this.horarioIdCargado = horario.id;
      this.__especialistaAgendaService
        .getDocument(horario.id)
        .then((res: any) => {
          // Verifica si res es undefined o no tiene la propiedad fecha
          if (!res || !res.fecha) {
            console.error('No se pudo obtener la fecha del documento');
            return;
          }
          // console.log('respuesta agenda especialista', res);
          // Obtenemos dia y hora de la agenda
          const fechaSolo = res.fecha.split('T')[0]; 
          const horaSolo = horario.hora.substring(0, 5); 
          const fechaHora = `${fechaSolo}T${horaSolo}:00`;
          this.datosConfirmar.fechaCita = formatDate(
            fechaHora,
            'd-MMM-yyyy HH:mm',
            'en-US'
          );
          
          this.datosConfirmar.horaCita = horaSolo;
          this.datosConfirmar.startEvent = new Date(res.fecha);
          this.datosConfirmar.nombresede = res.idSedeConsultorio.idSede.sede;
          this.datosConfirmar.idSede = res.idSedeConsultorio.idSede.$id;
          this.datosConfirmar.direccionSede =
            res.idSedeConsultorio.idSede.direccion;
          this.datosConfirmar.consultorio = res.idSedeConsultorio.descripcion;

          // CHECKEAR SI ES ONLINE O NO.
          const modalidadInicial =
            this.datosConfirmar.idSede === 'online' ? 'Online' : 'Presencial';
          this.formData.patchValue({
            modalidad: modalidadInicial,
          });
          this.getServiciosByModalidad();
        })
        .catch(error => {
          console.error('Error al obtener el documento:', error);
        });
    }

    // Validar si hay paciente o es paciente nuevo
    if (this.datosPaciente) {
      this.getServiciosByModalidad();
      this.datosConfirmar.paciente = this.datosPaciente.nombre;
      this.modalService.open(this.confirmModal, { centered: true });
      this.consultarPaquetesPaciente(this.datosPaciente.$id);
    } else {
      // Abre modal para insertar el paciente con el formulario
      const modalRef = this.modalService.open(this.createPaciente, {
        centered: true,
      });
      this.modalReferences['createPaciente'] = modalRef;

      // NO EXISTE EL PACIENTE O ES UN PACIENTE NUEVO
      // DATOS PARA EL FORMULARIO DE CREACIÓN DE PACIENTE NUEVO
      if (!this.datosBasicosCargados) {
        this.getTiposDocumento((data: { documents: any[] }) => {
          this.tiposDocumento = data.documents;
        });
        this.getParentesco((data) => {
          this.parentescos = data;
        });
        await this.getPaises();
        // await this.getCiudades(null);
        await this.getStatesCountries(null);
        this.datosBasicosCargados = true;
      }
    }
  }

  // #########################################################
  // Confirmar cita
  // Se valida la hora seleccionada este disponible y dentro del rango
  // #########################################################

  async confirmarCita() {
    this.submitted = true;
    if (this.formData.invalid) {
      return;
    } else {
      if (this.formData.value.duracion == '60') {
        const horaSeleccionada = this.datosConfirmar.horaCita;
        // console.log('Hora seleccionada:', horaSeleccionada);
        const [horas, minutos] = horaSeleccionada.split(':');
        const horaInicio = new Date();
        horaInicio.setHours(parseInt(horas), parseInt(minutos), 0, 0);

        const horaSiguiente = new Date(horaInicio.getTime() + 30 * 60 * 1000);
        const horaSiguienteStr =
          horaSiguiente.getHours().toString().padStart(2, '0') +
          ':' +
          horaSiguiente.getMinutes().toString().padStart(2, '0');

        const validacionHorarioSiguiente = this.horarios.some(
          (horario) => horario.hora === horaSiguienteStr
        );

        if (!validacionHorarioSiguiente) {
          Swal.fire({
            icon: 'error',
            title: 'El horario seleccionado no está disponible para una hora',
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }
      }
      this.validaSiTienePaquete();
    }
  }

  // Validación si el paciente tiene paquetes
  async validaSiTienePaquete() {
    let citasRestantes = 0;
    if (this.paquetesPaciente.length > 0) {
      // console.log(
      //   'servicio seleccionado:',
      //   this.servicioSeleccionado.tConsulta.$id
      // );
      const paqueteEncontrado = this.paquetesPaciente.find(
        (paquete) =>
          paquete.idServicio.tConsulta.$id ===
          this.servicioSeleccionado.tConsulta.$id
      );

      if (paqueteEncontrado && paqueteEncontrado.citasRestantes > 0) {
        // console.log('Paquete encontrado::', paqueteEncontrado);
        citasRestantes = paqueteEncontrado.citasRestantes - 1;
        // console.log('citasRestantes::', citasRestantes);

        return Swal.fire({
          title: 'Forma de pago de tu cita ',
          html: `
                        Tienes un paquete activo de: ${paqueteEncontrado.citasRestantes} citas restantes.<br>
                        Se hará el descuento de esta cita, continuar?
                    `,
          showCancelButton: true,
          confirmButtonColor: '#2ab57d',
          confirmButtonText: 'Generar Cita',
          cancelButtonText: `Cancelar`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.createCitaValidada('PAQUETE');
          }
        });
      } else {
        this.createCitaValidada('CONSULTORIO');
      }
    } else {
      // console.log('NO TIENE PAQUETE');
      this.createCitaValidada('CONSULTORIO');
    }
  }

  // SE CREA LA CITA
  async createCitaValidada(modoPago) {
    let validoPaquete = false,
      citasRestantes = 0;
    try {
      //Valiar si el paciente tiene paquetes
      if (this.paquetesPaciente.length > 0 && modoPago == 'PAQUETE') {
        const paqueteEncontrado = this.paquetesPaciente.find(
          (paquete) =>
            paquete.idServicio.tConsulta.$id ===
            this.servicioSeleccionado.tConsulta.$id
        );
        if (paqueteEncontrado) {
          // console.log('Paquete encontrado::', paqueteEncontrado);
          citasRestantes = paqueteEncontrado.citasRestantes - 1;
          const restarPaquete =
            await this.__paquetesAdquiridosService.updateDocument(
              paqueteEncontrado.$id,
              { citasRestantes: citasRestantes }
            );
          // console.log('Restar paquete::', restarPaquete);
          console.log('Response from updateDocument (paquete):', restarPaquete);
          validoPaquete = true;
        }
      }

      const cita: any = {
        detalle: this.formData.value.detalle,
        VrServicio: this.valorServicio,
        VrDescuento: parseInt(this.descuento.toString(), 10),
        VrTotal: this.valorTotal,
        idEstadoCita: validoPaquete ? 'agendada' : 'agendada',
        fechaCita: this.datosConfirmar.fechaCita,
        idSede: this.datosConfirmar.idSede,
        modalidad: this.formData.value.modalidad,
        servicioId: this.formData.value.servicio,
        IdEstadoPago: validoPaquete ? 'paquete' : 'creada',
        idPaciente: this.datosPaciente.$id,
        duracionCita: this.formData.value.duracion.toString(),
        idEspecialista: this.datosEspecialista.$id,
        tUsuarioAsigna: this.tUsuarioAsigna,
        idUsuarioAsigna: this.idUsuarioAsigna,
        consultorio: this.datosConfirmar.consultorio,
        nombreUsuarioAsigna: this.nombreUsuarioAsigna,
        convenio: this.formData.value.convenio === 'SI' ? true : false,
        idConvenio:
          this.formData.value.convenio === 'SI'
            ? this.datosPaciente.idConvenio.$id
            : null,
      };

      // console.log('cita:::', cita);
      // console.log('this.formData.value:::', this.formData.value);
      console.log('Data being sent to createDocument (cita):', cita);
      const createCita = await this.__citasservice.createDocument(cita);
      // console.log('createCita::', createCita);
      console.log('Response from createDocument (cita):', createCita);
      if (validoPaquete) {
        Swal.fire({
          icon: 'success',
          title: 'Se ha asignado la cita',
          text:
            'Se ha descontado una cita de su paquete, le quedan ' +
            citasRestantes +
            ' citas',
          showConfirmButton: false,
          timer: 3500,
        });
        this.modalService.dismissAll();
        this.router
          .navigateByUrl('/#misCitas')
          .then(() => {
            // Forzar recarga completa de la página
            window.location.reload();
          });
      } else {
        this.pasarelaPago(createCita.$id, this.valorTotal);
        await Swal.fire({
          icon: 'success',
          title: 'La cita se ha agendado!',
          text: 'Para confirmar la agenda de esta cita, el paciente debe realizar el pago.',
          showConfirmButton: false,
          timer: 3000,
        });
        this.modalService.dismissAll();
        this.router
          .navigateByUrl('/#misCitas')
          .then(() => {
            // Forzar recarga completa de la página
            window.location.reload();
          });
      }
    } catch (error) {
      console.log('error generando cita:', error);
    }
  }

  // FUNCION PARA OBTENER LA HORA ACTUAL DEL SISTEMA
  getCurrentTime(): number {
    let newDate = new Date(this.fechaActual.getTime());
    newDate.setHours(newDate.getHours() + 5);
    return newDate.getHours();
  }

  // #########################################################

  changeModalidad(event) {
    this.valorTotal = 0;
    this.getServiciosByModalidad();
  }

  // #########################################################
  changeServicio(event) {
    this.servicioSeleccionado = event;
    //console.log('SERVICIO SELECCIONADO::', event);
    
    this.valorServicio = 0;
    
    if (event != undefined) {
      if (event.duracion) {
        this.formData.get('duracion').setValue(event.duracion);
        this.duracion = event.duracion;
      } else {
        this.formData.get('duracion').setValue(30);
        this.duracion = 30;
      }
  
      //console.log('País del paciente:', this.datosPaciente.pais);
      
      if (this.datosPaciente.pais == 'CO') {
        this.valorServicio = event.valorCop;
        //console.log('Valor en COP seleccionado:', event.valorCop);
        //console.log('Valor servicio asignado (COP):', this.valorServicio);
      } else {
        this.valorServicio = event.valorUsd;
        //console.log('Valor en USD seleccionado:', event.valorUsd);
        //console.log('Valor servicio asignado (USD):', this.valorServicio);
      }
    }
    
    this.calcularValorTotal();
  }
  
  calcularValorTotal() {
    //console.log('=== CÁLCULO VALOR TOTAL ===');
    //console.log('Valor servicio antes del descuento:', this.valorServicio);
    //console.log('Descuento aplicado (%):', this.descuento);
    //console.log('Valor del descuento:', (this.valorServicio * this.descuento) / 100);
    
    this.valorTotal = this.valorServicio - (this.valorServicio * this.descuento) / 100;
    
    //console.log('Valor total calculado:', this.valorTotal);
    //console.log('========================');
  }

  // #########################################################
  // Formulario de paciente cita
  // #########################################################

  // cuando se cambia el radio select de si o no
  selectConvenio(event: any) {
    if (event.target.value === 'SI') {
      //console.log('datos paciente', this.datosPaciente);
      
      if (
        this.datosPaciente.idConvenio.requiereAprobacion &&
        this.datosPaciente.role === 'PACIENTE'
      ) {
        // Esperar a que la configuración esté cargada antes de acceder a ella
        this.configService.getConfigValue('EMPRESA', 'TELEFONO_SOPORTE').subscribe({
          next: (telefonoSoporte) => {
            if (telefonoSoporte) {
              this.telefono_soporte = telefonoSoporte;
              
              Swal.fire({
                icon: 'error',
                title: `Por favor, comuníquese con el Contact Center al teléfono ${this.telefono_soporte}`,
                showConfirmButton: true,
                // timer: 1500
              });
              
              this.selectNoConvenio(); // Cambia a 'NO'
            } else {
              console.error('No se pudo obtener el teléfono de soporte');
              Swal.fire({
                icon: 'error',
                title: 'Por favor, comuníquese con el Contact Center',
                showConfirmButton: true,
              });
              this.selectNoConvenio();
            }
          },
          error: (error) => {
            console.error('Error al obtener configuración:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error al cargar configuración',
              showConfirmButton: true,
            });
            this.selectNoConvenio();
          }
        });
      }
    } else {
      this.descuento = this.datosPaciente.idConvenio.descuento;
    }
    
    this.descuento = 0;
  }

  // Se utiliza la pasarela de pagos
  async pasarelaPago(idCita, valor) {
    const currentDate = new Date().toLocaleString('en-US', {
      timeZone: 'America/Bogota',
    });

    const dataCitaPago = {
      idCita: idCita,
      IdEstadoPago: 'creada',
      referencia: 'c_' + idCita,
      fechaPago: currentDate,
      valor: valor,
      descripcion: 'Compra Cita ADMIN',
    };
    const createCitaPago = await this.__citasPagosService.createDocument(
      dataCitaPago
    );
    // console.log('createCitaPago::', createCitaPago);
  }

  get form() {
    return this.formData.controls;
  }

  // #########################################################
  // Función de paises
  // #########################################################
  async getStatesCountries(event): Promise<void> {
    const valorSeleccionado = event ? event.iso2 : 'CO';
    this.departamentos = await firstValueFrom(
      this.__paisService.getStatesCountries(valorSeleccionado)
    );
  }
  async getPaises(): Promise<void> {
    this.paises = await firstValueFrom(this.__paisService.getCountries());
  }

  // DATOS PARA LOS PACIENTES NUEVOS.
  getTiposDocumento(dataComp) {
    this.__tiposDocumentoService.getTiposDocumento().then((data) => {
      dataComp(data);
    });
  }

  getParentesco(dataComp) {
    this.__parentescoService.getData().then((data) => {
      dataComp(data);
    });
  }

  selectNoConvenio() {
    this.formData.patchValue({
      convenio: 'NO',
    });
    // console.log(
    //   'DATA CONVENIO CUANDO CAMBIA SELECTNOCONVENIO: ',
    //   this.formData.value.convenio
    // );
  }

  // #################################
  // Listado de los servicios por modalidad son los servicios a listarse para ofrecerle al paciente
  getServiciosByModalidad() {
    // console.log('getServiciosByModalidad');
    // Ids de los servicios
    const dataArray = this.dataServiceArray();
    // console.log('cdataArray::', dataArray);
    this.formData.get('servicio').reset();
    this.servicios = [];
    this.__serviciosService
      .getDocumentsByModalidadIncludeArray(
        this.formData.value.modalidad,
        dataArray
      )
      .then((data) => {
        // Rafael
        // Filtra que los servicios sean para el especialista
        this.servicios = data.filter((servicio) => {
          const isColombian = this.datosPaciente?.idPaisResidencia === 'CO';
          // console.log('isColombian::', isColombian);
          const isCopValid = servicio.valorCop > 0;
          const isUsdValid = servicio.valorUsd > 0;
          return (isColombian && isCopValid) || (!isColombian && isUsdValid);
        });
        // console.log('DATA SERVICIOS:', this.servicios);
      });
  }

  // Función para obtener solo los ids de los servicios que presta el especialista
  // Toma solo los ids y devuelve un array para luego filtrar en los servicios a mostrar
  dataServiceArray() {
    return this.serviciosEspecialista.map((dato) => dato.servicioId.$id);
  }



  // Traer toda la información del especialista
  // Esta función de llama únicamente cuando se da click en  mostrarHorarios()
  getEspecialista() {
    this.__especialistasService
      .getEspecialistaOneCompleteNew(this.idEspecialista)
      .then((response) => {
        this.datosEspecialista = response;
        // console.log('this.datosEspecialista', this.datosEspecialista);
        // Trae los servicios que presta el especialista

        // Verificar que servicios existe y es un array
        if (
          this.datosEspecialista.servicios &&
          Array.isArray(this.datosEspecialista.servicios)
        ) {
          this.serviciosEspecialista = this.datosEspecialista.servicios.filter(
            (servicio) => {
              servicio.fDesde = new Date(servicio.fDesde).toUTCString();
              servicio.fHasta = new Date(servicio.fHasta).toUTCString();

              if (
                servicio.fDesde <= this.fechaActual.toUTCString() &&
                this.fechaActual.toUTCString() <= servicio.Fhasta
              ) {
                console.log(' 2', servicio);
              }
              return servicio;
            }
          );
        } else {
          console.log('servicios no existe o no es un array');
          this.serviciosEspecialista = [];
        }
      });
  }

  async consultarPaquetesPaciente(idPaciente: string) {
    // Validar que el ID del paciente existe
    if (!idPaciente || idPaciente === 'undefined') {
      console.warn('No se proporcionó ID de paciente para consultar paquetes');
      this.paquetesPaciente = [];
      return;
    }
    
    try {
      const paquetesPaciente = await this.__paquetesAdquiridosService.getDataByPaciente(idPaciente);
      this.paquetesPaciente = paquetesPaciente;
      //console.log('PAQUETES PACIENTE::', paquetesPaciente);
    } catch (error) {
      console.error('Error al consultar paquetes del paciente:', error);
      this.paquetesPaciente = [];
    }
  }

  // FUNCIÓN PARA MOSTRAR HORARIOS DESPUES DE DAR CLICK EN ELBOTON
  mostrarHorarios() {
    if (!this.horariosVisible) {
      this.horariosVisible = true;
      
      // Agrega esta línea para seleccionar el día de hoy
      this.seleccionarDia(this.fechaActual);
      
      this.generarDiasMostrados(); // Genera los días del carrusel (hoy, mañana, etc.)
    }
  
    // Función para obtener toda la información del especialista
    this.getEspecialista();
  }

  // Función para cargar horarios a mostrar
  private cargarHorarios() {
    // console.log('Cargando horarios...');
    this.cargando = true;

    if (!this.diaSeleccionado) {
      this.cargando = false;
      return;
    }

    const fechaInicial = this.diaSeleccionado
      .toISOString()
      .split('T')[0]
      .toString(); // YYYY-MM-DD
    const fechaFinal = this.diaSeleccionado
      .toISOString()
      .split('T')[0]
      .toString(); // YYYY-MM-DD

    // console.log('Fecha seleccionada:', fechaInicial);
    // console.log('Fecha seleccionada:', fechaFinal);
    this.__paisService
      .getTimeEspecialista(this.idEspecialista, fechaInicial, fechaFinal)
      .subscribe({
        next: (response) => {
          // console.log('Respuesta API:', response);

          if (
            response['status'] === 'success' &&
            response['message'].length > 0
          ) {
            this.horarios = response['message'][0].horas_disponibles || [];
            // console.log('Horarios cargados:', this.horarios);

            // Filtrar horarios si es hoy
            const hoy = new Date();
            const esDiaDeHoy =
              this.diaSeleccionado.toDateString() === hoy.toDateString();

            if (esDiaDeHoy) {
              const horaMinima = new Date(hoy.getTime() + 5 * 60 * 60 * 1000); // +5 horas
              const horaLimiteStr =
                horaMinima.getHours().toString().padStart(2, '0') +
                ':' +
                horaMinima.getMinutes().toString().padStart(2, '0');

              this.horarios = this.horarios.filter((horario) => {
                return horario.hora >= horaLimiteStr;
              });
            }
          } else {
            this.horarios = [];
            // console.log('No se encontraron horarios disponibles');
          }
          this.cargando = false;
        },
        error: (error) => {
          console.error('Error en la API:', error);
          this.horarios = [];
          this.cargando = false;
        },
      });
  }
  // Función lanzada cuando se ha seleccionado un día de la barra de dias
  seleccionarDia(dia: Date) {
    this.diaSeleccionado = dia;
    this.cargarHorarios();
  }

  get tituloHorarios(): string {
    if (!this.diaSeleccionado) return 'Horarios disponibles';

    const opciones: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
    };

    return `Horarios disponibles ${this.diaSeleccionado.toLocaleDateString(
      'es-ES',
      opciones
    )}`;
  }

  // FUNCIONES DE FECHA Y HORARIOS

  generarDiasMostrados() {
    this.diasMostrados = [];
    let diasAgregados = 0;
    let contador = 0;

    while (diasAgregados < 3) {
      const fecha = new Date(this.fechaActual);
      fecha.setDate(this.fechaActual.getDate() + contador);

      if (fecha.getDay() !== 0) {
        // 0 = Domingo
        this.diasMostrados.push(fecha);
        diasAgregados++;
      }
      contador++;
    }
  }

  // Función lanzada para mostrar los horarios adelante y atrás
  navegarDia(direccion: number) {
    this.fechaActual.setDate(this.fechaActual.getDate() + direccion);
    this.generarDiasMostrados();
  }

  formatearFecha(fecha: Date, indice: number): string {
    const hoy = new Date();
    const opciones: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      day: '2-digit',
      month: 'short',
    };

    if (indice === 0 && fecha.toDateString() === hoy.toDateString()) {
      return 'Hoy';
    }

    return fecha
      .toLocaleDateString('es-ES', opciones)
      .replace(/^\w/, (c) => c.toUpperCase());
  }

  formatearHora(hora: string): string {
    const [horas, minutos] = hora.split(':');
    const horaNum = parseInt(horas);
    const periodo = horaNum >= 12 ? 'PM' : 'AM';
    const horaFormateada =
      horaNum > 12 ? horaNum - 12 : horaNum === 0 ? 12 : horaNum;
    return `${horaFormateada}:${minutos} ${periodo}`;
  }

  get puedeRetroceder(): boolean {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaActualSinHora = new Date(this.fechaActual);
    fechaActualSinHora.setHours(0, 0, 0, 0);
    return fechaActualSinHora > hoy;
  }
}